// Keep the shared rich-text formatter's roll controls, with listeners instead of its legacy onclick attributes.
// Scope the observer to this list: lazy [table:] expansions arrive after the initial parsed-text mount.
export function wireLocationDescriptionActions(container: HTMLElement): void {
    const wire = (): void => {
        container.querySelectorAll<HTMLElement>('[data-ft-location-description] [onclick]').forEach(button => {
            const handler = button.getAttribute('onclick') || '';
            button.removeAttribute('onclick');
            const tableId = button.dataset.ftRandomTableRoll;
            if (tableId) {
                button.addEventListener('click', () => {
                    const roll = (window as Window & { ftRollRandomTableItem?: (id: string) => unknown }).ftRollRandomTableItem;
                    if (roll) void roll(tableId);
                    else if (typeof useAbility === 'function') void useAbility(tableId);
                });
                return;
            }
            // The shared formatter emits exactly eight single-quoted rollDice arguments. Read data only; never eval a handler.
            const call = /^rollDice\(((?:'[^']*'\s*,\s*){7}'[^']*')\);?$/.exec(handler);
            if (!call) return;
            const args = Array.from(call[1]!.matchAll(/'([^']*)'/g), part => part[1] ?? '');
            button.addEventListener('click', () => {
                if (typeof rollDice === 'function') void rollDice(args[0], args[1], args[2], args[3], args[4], args[5], args[6], args[7]);
            });
        });
    };
    wire();
    new MutationObserver(wire).observe(container, { childList: true, subtree: true });
}
